import { render, staticRenderFns } from "./HamburgerCorporate.vue?vue&type=template&id=31dfbe1e"
import script from "./HamburgerCorporate.vue?vue&type=script&lang=js"
export * from "./HamburgerCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports